import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { ClientMutator } from '@/lib/entity/client'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type ClientSchema = ClientMutator['merged']

export const ClientConverter: Converter<ClientSchema> = {
  icon: () => i18next.t('stages.icon.client'),
  title: () => i18next.t('stages.table.client'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.client.${column}`)
    return match(column)
      .with('name', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
